import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  transitionToInValidate?: boolean;
}

export const useSendBatchRiskAnalysisReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, transitionToInValidate = false }: HookProps) => {
      if (transitionToInValidate) {
        await request(
          {
            path: `batches/${batchId}/transition-to-invalidate`,
            method: 'POST',
            authenticate: true,
          },
          true,
        );
      }

      await request(
        {
          path: `batches/send-risk-analysis-report`,
          method: 'POST',
          authenticate: true,
          dataObject: {
            batchId,
          },
        },
        true,
      );
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['batch', variables.batchId, 'getUserReports'] });
      toast.success('Successfully sent the batch risk analysis report!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error sending the batch risk analysis report!');
    },
  });
};
